// extracted by mini-css-extract-plugin
module.exports = {"card":"AutoCompleteCardCmp_card__cRTUb"};